// From: https://loading.io/css/

import React from "react";

const EllipsisLoader = () => {
  return (
    <div className="pyht-loader lds-ellipsis">
      <div />
      <div />
      <div />
      <div />
    </div>
  );
};

export default EllipsisLoader;
